import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";

const links = [
  { label: "Calculator", id: "calculator" },
  { label: "Process", id: "process" },
  { label: "Work", id: "work" },
  { label: "Book", id: "book" },
];

export default function Nav() {
  const { user } = useAuth();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.7, ease: [0.2, 0.8, 0.2, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#F6F6F2]/90 backdrop-blur-md border-b border-[#E5E5DF]" : "bg-transparent"
      }`}
      data-testid="site-nav"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="font-head font-extrabold tracking-tighter text-lg" data-testid="nav-logo">
          OUTDOEM<span className="text-[#005CEE]">.</span>
        </button>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-[#111] hover:text-[#005CEE] transition-colors"
              data-testid={`nav-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link
            to={user ? "/admin" : "/admin/login"}
            className="hidden sm:inline text-xs font-mono2 text-[#8A8A85] hover:text-[#111] transition-colors"
            data-testid="nav-admin"
          >
            {user ? "DASHBOARD" : "ADMIN"}
          </Link>
          <button onClick={() => go("calculator")} className="btn-dark px-5 py-2 text-sm font-medium" data-testid="nav-cta">
            Get a Quote
          </button>
        </div>
      </div>
    </motion.header>
  );
}
